const uuid = '[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}'
const tablePath = new RegExp(`^/dashboard/m/(${uuid})/tables/(${uuid})$`, 'i')

/** Production links generated by the agent resolve in the viewer's current environment. */
export function parseTableLink(href: string | undefined, origin = window.location.origin) {
  if (!href) return null
  try {
    const url = new URL(href, origin)
    if (url.origin !== origin && url.origin !== 'https://app.paxton.ai') return null
    const match = url.pathname.match(tablePath)
    if (!match) return null
    return { matterId: match[1], tableId: match[2], href: url.pathname + url.search + url.hash }
  } catch {
    return null
  }
}
